module.exports = __webpack_public_path__ + "static/diamond-7e8689fa7aafdf6f0ddd43164d7a8d6c.svg";